import { buildCustomFieldDefaults, toFormAddress } from "components/BaseForm";

/** Initial form values, from the Case detail response. */
export const buildDefaultValues = ({ record, customFieldConfigs }) => ({
  name: record.name ?? "",
  entity_id: record.entity_id ?? null,
  case_investigators: (record.case_investigators ?? []).map(({ id }) => id),
  investigation_status_id: record.investigation_status_id ?? null,
  website: record.website ?? [],
  industry: record.industry ?? "",
  company_description: record.company_description ?? "",
  actionable_domain: record.actionable_domain ?? "",
  region_id: record.region_id ?? null,
  country: record.country ?? null,
  source_status_id: record.source_status_id ?? null,
  product_line_id: record.product_line_id ?? null,
  addresses: (record.addresses ?? []).map(address => toFormAddress(address)),
  tags: record.tags ?? [],
  custom_fields: buildCustomFieldDefaults(
    customFieldConfigs,
    record.custom_fields
  ),
});
